import api from '@/api'

export default {
  uploadMedia (data) {
    return api({
      method: 'POST',
      url: '/video/videoAdd',
      data
    })
  },
  videoListOrgan (params) {
    return api({
      method: 'GET',
      url: '/video/videoListOrgan',
      params
    })
  },
  videoListSystem (params) {
    return api({
      method: 'GET',
      url: '/video/videoListSystem',
      params
    })
  },
  videoListYouth (params) {
    return api({
      method: 'GET',
      url: '/video/videoListYouth',
      params
    })
  },
  videoListYouthForCoach (params) {
    return api({
      method: 'GET',
      url: '/video/videoListCoach',
      params
    })
  },
  videoListMy (params) {
    return api({
      method: 'GET',
      url: '/video/videoListMy',
      params
    })
  },
  videoDetail (uuid) {
    return api({
      method: 'GET',
      url: `/video/videoInfo/${uuid}`
    })
  },
  videoRemove (params) {
    return api({
      method: 'POST',
      url: '/video/videoRemove',
      params
    })
  },
  videoUpdate (data) {
    return api({
      method: 'POST',
      url: '/video/videoUpdate',
      data
    })
  },
  videoStatus (params) {
    return api({
      method: 'POST',
      url: '/video/videoUpdateSharingStatus',
      params
    })
  },
  videoListToObject (params) {
    return api({
      method: 'GET',
      url: '/video/videoListToObject',
      params
    })
  },
  videoListToObjectList (params) {
    return api({
      method: 'GET',
      url: '/video/videoListToObjectList',
      params
    })
  },
  unAssociatedVideoList (params) {
    return api({
      method: 'GET',
      url: '/video/unAssociatedVideoList',
      params
    })
  },
  videoAssociatedCreate (data) {
    return api({
      method: 'POST',
      url: '/video/videoAssociatedCreate',
      data
    })
  }
}
